module.exports = __webpack_public_path__ + "static/3-8d849fa7badbcd8eda9975669ec6be5e.jpg";